module.exports = __webpack_public_path__ + "fonts/Clash-Heavy.5857469.otf";